export const CAMPAIGN_TYPES = {
  ONGOING: 'ongoing',
  ONE_OFF: 'one_off',
};

export const WHATSAPP_MEDIA_LIMITS = {
  IMAGE: {
    types: ['image/jpeg', 'image/jpg', 'image/png'],
    maxSizeMB: 5,
  },
  VIDEO: {
    types: ['video/mp4', 'video/3gpp'],
    maxSizeMB: 16,
  },
  DOCUMENT: {
    types: ['application/pdf'],
    maxSizeMB: 100,
  },
};
